export const employerVerification = {
  pendingVerificationMsg: 'pending-verification-msg',
};
